import { Button, Divider, Header, Icon } from "semantic-ui-react";
import Feedback from "@components/Feedback";
import { useAuth } from "@src/auth";
import { useState, useEffect } from "react";
import axios from "axios";
import { gql, useQuery } from "@apollo/client";
import { getUserEmail } from "@components/Feedback";

import styles from "./style.module.css";

const { container, button, buttonWrapper, divider, top, bottom, sectionWrapper } = styles;

export default function Interviews({ onClose }) {
  const [interviewCount, setInterviewCount] = useState(0);
  const [offerCount, setOfferCount] = useState(0);
  const [updated, setUpdated] = useState(false);
  const [email, setEmail] = useState(null);
  const { user } = useAuth();

  const {
    data: userData,
    loading: dataLoading,
    error,
  } = useQuery(gql(getUserEmail), {
    variables: { userId: user?.username },
    fetchPolicy: "cache-and-network",
  });

  useEffect(() => {
    if (userData) {
      setEmail(userData?.getUserById?.email);
    }
  }, [userData]);

  useEffect(() => {
    getInterviewCount();
    getOfferCount();
  }, [updated]);

  const handleClick = (num) => {
    if (num > 0) {
      updateInterViewCount(num);
    }
  };

  const handleOfferClick = (num) => {
    if (num > 0) {
      updateOfferCount(num);
    }
  }

  async function getInterviewCount() {
    try {
      const myData = await axios.get(`/api/auto/user/`);
      setInterviewCount(myData.data?.Item?.interviewCount ?? 0);
    } catch (error) {
      console.error("Error fetching interview count:", error);
      return;
    }
  }

  async function getOfferCount() {
    try {
      const myData = await axios.get(`/api/auto/user/`);
      setOfferCount(myData.data?.Item?.offerCount ?? 0);
    } catch (error) {
      console.error("Error fetching interview count:", error);
      return;
    }
  }  

  async function sendInterviewNotification(interviewCount) {
    const interviewData = {
      email: email,
      interviewCount: interviewCount,
    };

    try {
      await axios.post("/api/interviews/", interviewData);
    } catch (error) {
      console.log("Error sending interview notification: ", error);
    }
  }

  async function sendOfferNotification(offerCount) {
    const offerData = {
      email: email,
      offerCount: offerCount,
    };

    try {
      await axios.post("/api/offers/", offerData);
    } catch (error) {
      console.log("Error sending interview notification: ", error);
    }
  }  

  const updateInterViewCount = async (num) => {
    try {
      const interviewCountResponse = await axios.post("/api/auto/interviews/", {
        interviewCount: num,
      });
      console.log(
        "Interview count updated successfully:",
        interviewCountResponse.data
      );
    } catch (error) {
      console.error("Failed to update user attributes:", error);
    } finally {
      sendInterviewNotification(num);
      setUpdated(!updated);
    }
  };

  const updateOfferCount = async (num) => {
    try {
      const response = await axios.post("/api/auto/offers/", {
        offerCount: num,
      });
      console.log(
        "Interview count updated successfully:",
        response.data
      );
    } catch (error) {
      console.error("Failed to update user attributes:", error);
    } finally {
      sendOfferNotification(num);
      setUpdated(!updated);
    }
  };  

  function Counter({ count, label, onChange}) {
    const [loading, setLoading] = useState(false)

    useEffect(() => {
      setLoading(false)
    }, [count])
    
    function makeChange (num) {
      setLoading(true)
      onChange(num)
    }
    
    return (
      <div className={styles.counter}>
        <h3>{label}</h3>
        <div className={styles.counterWrapper}>
          <Button disabled={interviewCount <= 0 || loading} circular icon='minus' color="blue" onClick={() => makeChange(count - 1)} />
          <div className={styles.count}>{count}</div>
          <Button disabled={loading} circular icon='plus' color="blue" onClick={() => makeChange(count + 1)} />
        </div>
      </div>
    )
  }  

  return (
    <div className={container}>
      <div className={top}>
        <h3>{`How's it going?`}</h3>
        <div className={styles.close}>
          <Icon name="close" onClick={onClose} />
        </div>
      </div>
      <div className={bottom}>
        <div className={`${sectionWrapper}`}>
          <Feedback
            text="Please leave us your feedback!"
            style={{ marginTop: "10px" }}
          />
        </div>
        <div className={divider} />
        <div className={sectionWrapper}>
          <div className={styles.interviewWrapper}>
            <Counter count={interviewCount} label="Interview Count" onChange={handleClick} />
            <Counter count={offerCount} label="Offer Count" onChange={handleOfferClick} />
          </div>
        </div>
      </div>
    </div>
  )
}
